import { IconMedalMulticolor, IconQuickResponseMulticolor } from '@blocket/blocket-ui'
import log from 'sentry/log'

export const DEFAULT_BADGE_SIZE = 24

const convertBadge = (badgeType, badgeSize) => {
  switch (badgeType) {
    case 'IconMedalMulticolor':
      return <IconMedalMulticolor width={badgeSize} height={badgeSize} />
    case 'IconQuickResponseMulticolor':
      return <IconQuickResponseMulticolor width={badgeSize} height={badgeSize} />
    default:
      return undefined
  }
}

// adds JSX formatted components
export const convertBadgesToJsx = (userData, badgeSize = DEFAULT_BADGE_SIZE) => {
  try {
    const { badges } = userData

    const formatBadges = badges.map((badge) => {
      const convertedBadge = convertBadge(badge.iconBlocketUi, badgeSize)

      return {
        ...badge,
        ...(convertedBadge && {
          component: convertedBadge,
        }),
      }
    })

    return {
      ...userData,
      badges: formatBadges,
    }
  } catch (error) {
    log.warn(`Failed to convert badges to JSX. Error: ${error}`)
    return userData
  }
}
